import { Checkbox } from 'antd';
import { useFormikContext } from 'formik';
import useSmartField from 'hooks/useSmartField';
import { useTranslate } from '@tolgee/react';
import { FV, GatherContainer } from './share';
import WaitReply from './WaitReply';

const refundScenarios: Remind.RefundScenario[] = [
  'onlyRefundNotReceipt',
  'onlyRefundItemMissing',
  'onlyRefundWrongItem',
  'onlyRefundPhysicalDmg',
  'onlyRefundFunctionalDmg',
];

function RefundField() {
  const { t } = useTranslate();

  const scenarioLabelMap: Record<Remind.RefundScenario, string> = {
    onlyRefundNotReceipt: t('aide.未收到货物'),
    onlyRefundItemMissing: t('aide.收到货物少件'),
    onlyRefundWrongItem: t('aide.收到货物错误'),
    onlyRefundPhysicalDmg: t('aide.收到货物破损'),
    onlyRefundFunctionalDmg: t('aide.收到货物无法使用'),
  };

  const {
    values: {
      orderAbandonGroup: { enable },
    },
  } = useFormikContext<FV>();

  const {
    field: { value, onChange },
  } = useSmartField<
    FV['orderAbandonGroup']['remindScene']['REFUND_RETRIEVE']['refundRetrieveConfig']
  >('orderAbandonGroup.remindScene.REFUND_RETRIEVE.refundRetrieveConfig');

  const disabled = !enable || refundScenarios.every((scenario) => !value[scenario]);

  const { waitReply, closeCondition } = value;

  const { cancelled, acceptedOrRefundPaid, closed } = closeCondition;

  return (
    <GatherContainer>
      <h4>{t('newScene.REFUND_RETRIEVE')}</h4>
      <div>
        <h5>{t('remind.选择x场景', { x: t('newScene.REFUND_RETRIEVE') })}</h5>
        {refundScenarios.map((scenario) => {
          const { [scenario]: checked } = value;

          const { [scenario]: label } = scenarioLabelMap;

          return (
            <Checkbox
              key={scenario}
              disabled={!enable}
              checked={checked}
              onChange={({ target: { checked } }) => {
                onChange({
                  ...value,
                  [scenario]: checked,
                });
              }}
            >
              {label}
            </Checkbox>
          );
        })}
      </div>
      <WaitReply
        waitReply={waitReply}
        onWaitReplyChange={(waitReply) => onChange({ ...value, waitReply })}
        disabled={disabled}
      />
      <div>
        <h5>{t('remind.自动关闭当前会话的重要提醒')}</h5>
        <div>
          <Checkbox
            disabled={disabled}
            checked={cancelled}
            onChange={({ target: { checked } }) =>
              onChange({
                ...value,
                closeCondition: {
                  ...closeCondition,
                  cancelled: checked,
                },
              })
            }
          >
            {t('remind.买家撤回仅退款申请')}
          </Checkbox>
          <Checkbox
            disabled={disabled}
            checked={closed}
            onChange={({ target: { checked } }) =>
              onChange({
                ...value,
                closeCondition: {
                  ...closeCondition,
                  closed: checked,
                },
              })
            }
          >
            {t('remind.平台拒绝仅退款申请')}
          </Checkbox>
          <Checkbox
            disabled={disabled}
            checked={acceptedOrRefundPaid}
            onChange={({ target: { checked } }) =>
              onChange({
                ...value,
                closeCondition: {
                  ...closeCondition,
                  acceptedOrRefundPaid: checked,
                },
              })
            }
          >
            {t('remind.卖家同意仅退款申请')}
          </Checkbox>
        </div>
      </div>
    </GatherContainer>
  );
}

export default RefundField;
